/* eslint-disable no-nested-ternary */

import * as React from 'react';

import Text from 'crehana-ui/Text';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const Prices: React.FC<Partial<CourseCardProps>> = props => {
  const {
    prices,
    bundlePrice,
    courseType,
    customBundle,
    user,
    dark,
    classification,
  } = props;

  if ((user && user.isPremiumMember) || customBundle) {
    return null;
  }

  if (courseType === 'membership') {
    return <div className="h-24" />;
  }

  if (bundlePrice && prices) {
    return (
      <Text type="currency" data-testid="card-real-price">
        {`${prices.currencySymbol}${prices.realPrice!.toLocaleString('en-US')}`}
      </Text>
    );
  }

  if (classification === 'bundle' && prices && prices.totalPrice) {
    return (
      <React.Fragment>
        <Text
          className="course-card-price"
          data-testid="card-price"
          type="currency"
          color="red-main"
        >
          {`${prices.currencySymbol}${
            prices.currencySymbol === 'R$'
              ? prices.price!.toLocaleString()
              : prices.price!.toLocaleString('en-US')
          }`}
        </Text>
        <Text
          className="course-card-discount"
          type="discount-s"
          color="gray-dark"
          data-testid="card-real-price"
        >
          {`${prices.currencySymbol}${
            prices.currencySymbol === 'R$'
              ? prices.totalPrice!.toLocaleString()
              : prices.totalPrice!.toLocaleString('en-US')
          }`}
        </Text>
      </React.Fragment>
    );
  }

  const priceColor =
    prices && prices.discount && prices.discount > 0 ? 'red-main' : 'primary-main';

  if (courseType === 'temporal-access') {
    return <div style={{ height: 22 }} />;
  }

  return (
    <div
      className="PricesComponent flex items-center w-full"
      css={`
        .course-card-price {
          line-height: 22px;
        }
        .course-card-discount {
          font-size: 14px;
        }
      `}
    >
      {prices ? (
        prices && prices.price === 0 ? (
          <Text
            type="currency"
            className="course-card-price"
            color="primary-main"
          >
            Gratis
          </Text>
        ) : (
          <>
            <Text
              className="course-card-price"
              data-testid="card-price"
              type="currency"
              color={dark ? 'secondary-light' : priceColor}
            >
              {`${prices.currencySymbol}${
                prices.currencySymbol === 'R$'
                  ? prices.price!.toLocaleString()
                  : prices.price!.toLocaleString('en-US')
              }`}
            </Text>
            {prices.discount && prices.discount > 0 ? (
              <Text
                className="course-card-discount"
                type="discount"
                color="gray-dark"
                data-testid="card-real-price"
              >
                {`${prices.currencySymbol}${
                  prices.currencySymbol === 'R$'
                    ? prices.realPrice!.toLocaleString()
                    : prices.realPrice!.toLocaleString('en-US')
                }`}
              </Text>
            ) : null}
          </>
        )
      ) : null}
    </div>
  );
};

export default Prices;
